import type { SxProps, Theme } from '@mui/material/styles';
import bgRfxToRmf from '../../../assets/images/sso/bgRfxToRmf.png';

export const pageSx: SxProps<Theme> = {
  minHeight: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundImage: `url(${bgRfxToRmf})`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  px: 2,
};

export const cardSx: SxProps<Theme> = {
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '16px',
  width: '512px',
  p: '32px',
  backgroundColor: '#111217',
  borderRadius: '14px',
  border: '1px solid rgba(255,255,255,0.1)',
  outline: 'none',
  textAlign: 'center',
};

export const primaryButtonSx: SxProps<Theme> = {
  width: '100%',
  borderRadius: '8px',
  border: '1px solid #FFFFFF1A',
  backgroundColor: '#354EEF',
  textTransform: 'none',
  fontWeight: 400,
  py: 1,
  fontSize: '0.9rem',
  color: '#FFFFFF',
  '&:hover': { background: '#2a3ec0' },
  '&:disabled': {
    background: 'rgba(255, 255, 255, 0.1)',
    color: 'rgba(255, 255, 255, 0.3)',
  },
};

export const outlinedButtonSx: SxProps<Theme> = {
  color: 'rgba(255, 255, 255, 0.85)',
  borderColor: 'rgba(255, 255, 255, 0.3)',
  textTransform: 'none',
  '&:hover': { borderColor: '#fff', background: 'rgba(255,255,255,0.05)' },
};

export const resendButtonSx: SxProps<Theme> = {
  textTransform: 'none',
  color: '#354EEF',
  fontWeight: 600,
  fontSize: '0.85rem',
  '&:hover': { background: 'rgba(53, 78, 239, 0.1)' },
};

export const iconContainerSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 48,
  height: 48,
  borderRadius: '12px',
  backgroundColor: 'rgba(255, 255, 255, 0.05)',
};

export const infoBoxSx: SxProps<Theme> = {
  width: '100%',
  borderRadius: '12px',
  border: '1px solid rgba(76, 175, 80, 0.3)',
  backgroundColor: 'rgba(76, 175, 80, 0.05)',
  px: 2.5,
  py: 2,
};

export const errorInfoBoxSx: SxProps<Theme> = {
  width: '100%',
  borderRadius: '12px',
  border: '1px solid rgba(244, 67, 54, 0.3)',
  backgroundColor: 'rgba(244, 67, 54, 0.1)',
  px: 2.5,
  py: 2,
};

export const loadingInfoBoxSx: SxProps<Theme> = {
  backgroundColor: 'rgba(255, 255, 255, 0.05)',
  border: '1px solid rgba(255, 255, 255, 0.1)',
  borderRadius: '8px',
  px: 2,
  py: 1.5,
  width: '100%',
};

export const successAlertSx: SxProps<Theme> = {
  width: '100%',
  backgroundColor: 'rgba(76, 175, 80, 0.1)',
  color: '#4caf50',
  borderRadius: 2,
  '& .MuiAlert-icon': { color: '#4caf50' },
};

export const errorAlertSx: SxProps<Theme> = {
  width: '100%',
  backgroundColor: 'rgba(244, 67, 54, 0.1)',
  color: '#f44336',
  borderRadius: 2,
  '& .MuiAlert-icon': { color: '#f44336' },
};

export const tfaCancelButtonSx: SxProps<Theme> = {
  color: 'rgba(255,255,255,0.5)',
  textTransform: 'none',
};

export const linkTextSx: SxProps<Theme> = {
  color: '#354EEF',
};

export const tfaStepLabelSx: SxProps<Theme> = {
  color: '#CCD4FF',
  fontSize: '0.8rem',
  alignSelf: 'flex-start',
};

export const tfaMethodChipSx: SxProps<Theme> = {
  display: 'inline-block',
  borderRadius: '8px',
  backgroundColor: 'rgba(204, 212, 255, 0.1)',
  px: 2,
  py: 0.5,
  color: '#CCD4FF',
  fontSize: '0.85rem',
};

export const digitBoxSx: SxProps<Theme> = {
  width: 56,
  height: 56,
  minWidth: 56,
  minHeight: 56,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: 'rgba(255, 255, 255, 0.05)',
  borderRadius: '10px',
  border: '1px solid rgba(255, 255, 255, 0.1)',
  color: '#fff',
  fontSize: '1.4rem',
  fontWeight: 600,
  '& input': {
    textAlign: 'center',
    padding: 0,
    width: '100%',
    height: '100%',
    color: '#fff',
  },
};

export const digitBoxFocusedSx: SxProps<Theme> = {
  borderColor: '#354EEF',
};

export const digitBoxFilledSx: SxProps<Theme> = {
  borderColor: 'rgba(255, 255, 255, 0.25)',
};
